import { isValid } from 'date-fns'

export const required = v => {
  if (Array.isArray(v)) {
    if (v.length) {
      return true
    }
  } else if (v) {
    return true
  }

  return 'Obligatorisk'
}

export const validDate = v => {
  if (v === null || !isValid(new Date(v))) {
    return 'Måste vara ett giltigt datum'
  }
  return true
}

export const validTime = v => !!v || 'Ej giltig tid'
